import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    revokedContent: {
      textAlign: 'left',
      display: 'flex',
      width: 'fit-content',
      borderRadius: 4,
      height: 19,
      paddingLeft: 4,
      paddingRight: 4,
      backgroundColor: '#FF8F94',
      color: variables.white,
    },
    details: {
      height: 113,
      minWidth: 150,
      minHeight: 113,
      borderRadius: 8,
      padding: 16,
      backgroundColor: variables.white,
      textAlign: 'start',
      width: '49%',
      flexBasis: '49%',
      justifyContent: 'space-between',
    },
    email: {
      display: 'none',
      '@media (max-width: 600px)': {
        marginBottom: 15,
        height: 113,
        minWidth: 150,
        minHeight: 113,
        borderRadius: 8,
        padding: 16,
        backgroundColor: variables.white,
        textAlign: 'start',
        display: 'block',
        cursor: 'pointer',
      },
    },
    detailsTitle: {
      fontWeight: 400,
      color: variables.black50,
    },
    detailsItem: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    accordionSubHeader: {
      textAlign: 'start',
      fontSize: '16px !important;',
      color: variables.black50,
      fontWeight: 400,
      '@media (max-width: 600px)': {
        display: 'none',
      },
    },
  }),
);
